import api from '@/apis'

export const fetchList = params => api.get(`/referralRule`, { params })
export const setActiveState = (id) => api.delete(`/referralRule/${id}`)
export const getReferralRule = (id) => api.get(`/referralRule/${id}`)
